import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { appVersion } from "../../../utils/app-version";

type AboutItem = {
  title: string;
  route: string;
  state: { back: boolean; title: string };
  id: string;
};

export function AboutCard() {
  const [version, setVersion] = useState<string>("");

  useEffect(() => {
    loadVersion();
  }, []);

  const loadVersion = async () => {
    if (!Capacitor.isNativePlatform()) return;
    const version = await appVersion();
    setVersion(version);
  };

  const aboutItems: AboutItem[] = [
    {
      title: "FAQs",
      route: "/home/records-policy",
      state: { back: true, title: "FAQs" },
      id: "faqs",
    },
    {
      title: "Privacy Policy",
      route: "/home/privacy",
      state: { back: true, title: "Privacy Policy" },
      id: "privacy-policy",
    },
    {
      title: "Terms of Use",
      route: "/home/terms",
      state: { back: true, title: "Terms of Use" },
      id: "terms-of-use",
    },
    {
      title: "COVID-19 Privacy Policy",
      route: "/home/covid-policy",
      state: { back: true, title: "COVID-19 Privacy Policy" },
      id: "covid-policy",
    },
    {
      title: "About Docket®",
      route: "/home/about",
      state: { back: true, title: "About Docket®" },
      id: "about",
    },
    {
      title: "Share Feedback",
      route: "/home/feedback",
      state: { back: true, title: "Share Feedback" },
      id: "feedback",
    },
  ];

  const titleWithVersion = version ? `About - version ${version}` : "About";

  return (
    <div className="card bg-base-100 max-md:rounded-none md:hidden">
      <div className="bg-secondary text-secondary-content px-4 py-3 max-md:rounded-none">
        <h2 className="text-xl font-bold" data-testid="about-version">
          {titleWithVersion}
        </h2>
      </div>
      <div className="card-body">
        <ul className="flex flex-wrap gap-2">
          {aboutItems.map((item) => (
            <li key={item.id}>
              <Link className="btn" to={item.route} state={item.state} data-testid={item.id}>
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AboutCard;
